import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddCarrera extends Component {
  static displayName = AddCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      anioImplementacion: new Date().getFullYear().toString(),
      name: '',
      resolucionMinisterial: '',
      errorMessage: '',
      redirect: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWCarreras');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleFieldChange = (field) => (e) => {
    this.clearFeedback();
    this.setState({ [field]: e.target.value });
  };

  isFormValid() {
    return (
      this.state.name.trim().length > 0
      && this.state.anioImplementacion.trim().length > 0
      && this.state.resolucionMinisterial.trim().length > 0
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveCarrera();
  }

  async saveCarrera() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/Carreras/', {
      method: 'POST',
      body: JSON.stringify({
        CarreraNombre: this.state.name.trim(),
        CarreraAnioImplementacion: this.state.anioImplementacion.trim(),
        CarreraResolucionAprobacion: this.state.resolucionMinisterial.trim(),
        CarreraExtinta: 'N',
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar la carrera. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-carreras" />;
    }

    const { loading, name, anioImplementacion, resolucionMinisterial, errorMessage } = this.state;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-carreras">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Carrera</h1>
        <p className="md-form-page__subtitle">
          Complete los datos para registrar una nueva carrera en el instituto.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando carrera, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="carrera-nombre">
                Nombre Completo
              </label>
              <input
                id="carrera-nombre"
                className="md-form-page__input"
                type="text"
                name="name"
                autoComplete="off"
                placeholder="Ingrese nombre completo"
                value={name}
                onChange={this.handleFieldChange('name')}
                disabled={loading}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="carrera-anio">
                Año de Implementación
              </label>
              <input
                id="carrera-anio"
                className="md-form-page__input"
                type="text"
                name="anioImplementacion"
                autoComplete="off"
                placeholder="Ingrese año de implementación"
                value={anioImplementacion}
                onChange={this.handleFieldChange('anioImplementacion')}
                disabled={loading}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="carrera-resolucion">
                Resolución Ministerial
              </label>
              <input
                id="carrera-resolucion"
                className="md-form-page__input"
                type="text"
                name="resolucionMinisterial"
                autoComplete="off"
                placeholder="Ingrese resolución de aprobación"
                value={resolucionMinisterial}
                onChange={this.handleFieldChange('resolucionMinisterial')}
                disabled={loading}
                required
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={loading}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
